module.exports = __webpack_public_path__ + "img/IMG-20200715-WA0014.9d440379.jpg";